import { render, staticRenderFns } from "./BalancePanel.vue?vue&type=template&id=6059af20&scoped=true"
import script from "./BalancePanel.vue?vue&type=script&lang=js"
export * from "./BalancePanel.vue?vue&type=script&lang=js"
import style0 from "./BalancePanel.vue?vue&type=style&index=0&id=6059af20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059af20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6059af20')) {
      api.createRecord('6059af20', component.options)
    } else {
      api.reload('6059af20', component.options)
    }
    module.hot.accept("./BalancePanel.vue?vue&type=template&id=6059af20&scoped=true", function () {
      api.rerender('6059af20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/dashboard/components/BalancePanel.vue"
export default component.exports